exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-13ece836]{\n\ttable-layout: fixed ;\n}\ntable[data-v-13ece836],td[data-v-13ece836] {\n\tbackground-color: #ffffff;\n\tempty-cells: show;\n}\nthead[data-v-13ece836]{\n\tbackground: #d0d0d0;\n\tposition:static;\n\ttop:0px;\n}\ntd[data-v-13ece836]{\n\tpadding:0px;\n}\ntd[data-v-13ece836]:nth-child(1){\n\theight:30px;\n\tfont-size: 12px;\n}\n.blockcontainer[data-v-13ece836]{\n\tposition:relative;\n\theight:720px;\n\tmargin:0px;\n\tpadding:0px;\n\n\tbackground-size: 10px 30px;\n\tbackground-image:\n\tlinear-gradient(to bottom, #f0f0f0 1px, transparent 1px);\n}\n.time[data-v-13ece836]{\n\topacity:.5;\n}\n.largetext[data-v-13ece836]{\n\tfont-size:32px;\n\tmargin-left:0px;\n}\n.parent[data-v-13ece836]{\n\tdisplay:flex;\n\tmax-width:100%;\n\tmargin:auto;\n\tmargin-top:10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13ece836","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/timetable_overview.vue
// module id = 822
// module chunks = 0